import { getLeaseFullname } from './utils';

interface LeaseNameProps {
  lease?: MagicDoor.Api.HydratedLeaseDto;
}

export const LeaseName = (props: LeaseNameProps) => {
  return <div class="max-w-full cursor-pointer break-words text-sm font-medium text-text-level01">{getLeaseFullname(props.lease)}</div>;
};
